import apiLogin from '@/model/login'
import sensors from 'sa-sdk-javascript'
import { getLoginKey } from '@/utils/cache'

const getCgv = () => {
  if (localStorage.cgv) {
    return localStorage.cgv
  }
  localStorage.cgv = Math.floor(Math.random() * 10)
  return localStorage.cgv
}
const state = {
  dialogVisibleZww: false,
  dialogVisibleZwwConfig: false,
  zwwcertification: false,
  zwwRegistered: false,
  activeIndex: 0,
  userinfo: {},
  successLogin: false,
  international: [],
  active: 0,
  username: '',
  cgv: getCgv(),
  wxInfo: {},
  aliPayInfo: {},
  zwwinfo: {}
}

const getters = {
  zwwinfo: (state) => state.zwwinfo,
  dialogVisibleZww: (state) => state.dialogVisibleZww,
  dialogVisibleZwwConfig: (state) => state.dialogVisibleZwwConfig,
  zwwcertification: (state) => state.zwwcertification,
  zwwRegistered: (state) => state.zwwRegistered,
  userId: (state) => state.userinfo?.userId,
  username: (state) => state.userinfo.phone || state.userinfo.nickName,
  phone: (state) => state.userinfo.phone,
  nickname: (state) => state.userinfo.nickName,
  get_userinfo: (state) => state.userinfo,
  activeIndex: (state) => state.activeIndex,
  cgv: (state) => state.cgv
}
const mutations = {
  SET_ZWWINFO(state, zwwinfo) {
    state.zwwinfo = zwwinfo
  },
  SET_REGISTERED(state, status) {
    state.zwwRegistered = status
  },
  SET_ZWW(state, status) {
    state.dialogVisibleZww = status
  },
  SET_ZWWCONFIG(state, status) {
    state.dialogVisibleZwwConfig = status
  },
  SET_CERTIFICATION(state, status) {
    state.zwwcertification = status
  },
  SET_ACTIVE_INDEX(state, index) {
    state.activeIndex = index
  },
  SET_USER_INFO(state, info) {
    state.userinfo = info
  }
}
const actions = {
  async logout() {
    try {
      await apiLogin.singleExit()
      window.location.replace(`/login?return_url=${encodeURIComponent(window.location.href)}`)
    } catch (err) {
      console.log(err)
    }
  },
  async getUserInfo({ commit, state }) {
    try {
      if (getLoginKey()) {
        const data = await apiLogin.userInfo()
        state.successLogin = true
        commit('SET_USER_INFO', data)
        sensors.login(data.userId)
      }
    } catch (e) {
      console.log(e)
    }
  },
  setActiveIndex({ commit }, value) {
    commit('SET_ACTIVE_INDEX', value)
  }
  // setUserINFO({ commit, state }, info) {
  //   state.successLogin = true
  //   commit('SET_USER_INFO', info)
  //   sensors.login(info.user.userId)
  // }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
